// Client REAL de Análisis de ventas — endpoint 29a, desplegado en `retail-wizard-business`.
//
// El path correcto es `/backoffice/sales/analytics`. El front venía llamando `/backoffice/analytics`
// —el path que la propuesta había pedido antes de que el endpoint existiera— y eso era un 404 fijo:
// la pantalla nunca pintó nada, y no por falta de backend.
//
// Sin query params: el retailer se impone desde el token y los tres rangos vienen siempre juntos.
import { apiFetch } from '../../../client';
import type { Financier } from '../../retail-org/backoffice';
import type { AnalyticsApi, AnalyticsResponse } from './analyticsContract';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

/**
 * El silo llama `NONE` a la venta de contado; el resto del portal la llama `CASH` (`Financier` de
 * `retail-org`). Se traduce en el borde —acá— y no en la UI: si cada pantalla tradujera por su
 * cuenta, la primera que se olvidara pintaría una columna «NONE» sin etiqueta.
 */
const FINANCIER_FROM_SILO: Record<string, Financier> = {
    NONE: 'CASH',
    SUREKEEP: 'SUREKEEP',
    PAYJOY: 'PAYJOY',
    CREDIYA: 'CREDIYA',
    LESPAGO: 'LESPAGO',
    INNOVA: 'INNOVA',
};

/** Traduce las financieras de la respuesta. El resto del shape ya es espejo del silo. */
function adaptFinanciers(response: AnalyticsResponse): AnalyticsResponse {
    const ranges = Object.fromEntries(
        Object.entries(response.ranges).map(([key, block]) => [
            key,
            {
                ...block,
                financierMix: block.financierMix.map((row) => ({
                    ...row,
                    cells: row.cells.map((cell) => ({
                        ...cell,
                        financier: FINANCIER_FROM_SILO[cell.financier] ?? cell.financier,
                    })),
                })),
            },
        ]),
    );
    return { ...response, ranges };
}

export const analyticsClient: AnalyticsApi = {
    getAnalytics: async () => {
        const response = await apiFetch<AnalyticsResponse>('/backoffice/sales/analytics', {
            baseUrl: BASE_URL,
        });
        return adaptFinanciers(response);
    },
};
